import { apiResponseToFields } from './quoteTemplate.adapters.in'
import { domainToApi } from './quoteTemplate.adapters.out'

export const quoteTemplateAdapters = {
  toCube: apiResponseToFields,
  toApi: domainToApi
}
